// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import Modal from '../common/modal';

import { selectUIProgress, selectUIModal } from '../ui/ui.helpers.js';
import { setModal } from '../ui/ui.actions.js';

import { refundTransaction, saveTransaction } from './transaction.actions.js';
import { invoiceSelector } from '../invoice/invoice.selectors.js';

import { transactionsSelector } from './transaction.selectors.js';
import { EDIT_TRANSACTION } from './transaction.const.js';

import { amountPattern } from '../payments/payments.const.js';

class TransactionModifyModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      amount: ''
    };

    this.closeModal = this.props.setModal.bind(this, false, EDIT_TRANSACTION);

    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      amount: nextProps.transactions[nextProps.transactionId]
        ? nextProps.transactions[nextProps.transactionId].amount
        : ''
    });
  }

  onSubmit: Function;
  onSubmit(e) {
    e.preventDefault();

    return this.props.actionType === 'refund'
      ? this.props.refundTransaction({
          amount: this.state.amount,
          id: this.props.transactionId
        })
      : this.props.saveTransaction({
          amount: this.state.amount,
          id: this.props.transactionId
        });
  }

  onChange: Function;
  onChange(e) {
    return this.setState({
      amount: e.currentTarget.value
    });
  }

  render() {
    const { actionType, isOpen, transactions, transactionId, progress, invoice } = this.props;

    const transaction = transactions[transactionId];

    if (!transaction) return null;

    const actionText =
      actionType === 'refund' ? 'Refund' : actionType === 'edit' ? 'Edit' : 'Increase';

    return (
      <Modal
        isOpen={isOpen}
        onClose={this.closeModal}
        className="row smart-dialog-modern"
        scrollable={false}
        header={<div className="smart-dialog-header">{actionText} transaction</div>}
        footer={
          <div className="col-md-12 buttons">
            <label
              htmlFor="btn-submit-transaction-modal"
              disabled={progress || !this.state.amount}
              className="btn btn-success pull-right"
            >
              {actionText}
            </label>
          </div>
        }
      >
        <form onSubmit={this.onSubmit}>
          {transaction.maxAmount && (actionType === 'increase' || actionType === 'edit') ? (
            <span>
              You can {actionType} this transaction to ${transaction.maxAmount}
            </span>
          ) : null}
          <div className="spaced-group">
            <input
              type="text"
              pattern={amountPattern}
              className="form-control"
              value={this.state.amount}
              onChange={this.onChange}
              disabled={progress}
              required
            />
          </div>

          {invoice && actionType === 'edit' && invoice.balance ? (
            <span>Your invoice balance ${invoice.balance}</span>
          ) : null}

          <input type="submit" className="hidden" id="btn-submit-transaction-modal" />
        </form>
      </Modal>
    );
  }
}

const progressSelector = selectUIProgress();
const modalSelector = selectUIModal(EDIT_TRANSACTION);

const mapStateToProps = state => ({
  isOpen: modalSelector(state),
  progress: progressSelector(state),
  transactions: transactionsSelector(state),
  invoice: invoiceSelector(state)
});

export default connect(
  mapStateToProps,
  {
    setModal,
    refundTransaction,
    saveTransaction
  }
)(TransactionModifyModal);
